import React from 'react'
import payRecieve from "../../../assets/images/pay-recieved.png"

const paymentrecieved = () => {
  return (
    <section className="payment-recieved total-cost">
      <div >
        <div className="col-md-12 all-one-title ">Payments Recieved</div>

        <div className="fare-detail-content ">
        <div className="col-md-12 initial-charge"> <img src={payRecieve} alt="pay-recieve-icon"  />  * * A ₹ 5,000 refundable deposit is included below</div>
      </div>

        <div className="fare-detail-content ">
          <div className="fare">
            <div className="b-time"> Credit Card</div>
            <div className="b-exact-time">Jul 08, 2016</div>
          </div>
          <div className="price">₹12,875 </div>
        </div>

        <div className="fare-detail-content total-paid">
          <div className="fare">Total Paid</div>
          <div className="price">₹12,875</div>
        </div>
      </div>

    </section>
  )
}

export default paymentrecieved